import styled from 'styled-components'
import { colors } from 'client/styles'

export const CancellationMessageBase = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.grey2};
`

export const Title = styled.div`
  font-weight: 700;
`

export const Message = styled.div``
